import React, { useEffect, useState } from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import { deleteImage, getGallery, postImage } from "../../helpers/lib/axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { IsTokenExpired } from "../../helpers/lib/jwt";
import { useAppToast } from "../../helpers/lib/useAppToast";

export default function Gallery() {
  pageTitle("Gallery");
  const navigate = useNavigate();

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const toast = useAppToast()

  const [gallery, setGallery] = useState([]);
  

  const handleFileChange = (event) => {
    if (!event.target.files) return;

    const filesArray = Array.from(event.target.files);
    setSelectedFiles(filesArray);

    // Generate preview URLs
    const previews = filesArray.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };

  const handleUpload = async () => {
    const token = Cookies.get("noohraToken");
    if (!token) {
      navigate("/signup");
      return;
    }
    if (IsTokenExpired(token)) {
      Cookies.remove("noohraToken");
      console.log("Token expired");
      navigate("/signup");
      return;
    }
    if (selectedFiles.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    setUploading(true);

    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("images", file)); // Adjust field name to match API requirements

      const response = await postImage(formData);
      console.log("Upload successful:", response);

      toast({
        status: "success",
        description: response.data.message || "Images uploaded successfully",
      })
      // Assuming response contains URLs of uploaded images
      setUploadedImages(response.data.images || []);
      setSelectedFiles([]);
      setImagePreviews([]);
      getGallery().then(gal => {
        console.log(gal)
        setGallery(gal?.data);
      }).catch(err => console.log(err))
    } catch (error) {
      console.error("Upload failed:", error);
      toast({
        status: "error",
        description: error.response.data.message || "Failed to upload images",
       });
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    const token = Cookies.get('noohraToken')
    if (!token) {
      navigate('/signup')
      return;
    }
      getGallery().then(gal => {
        console.log(gal)
        setGallery(gal?.data);
      }).catch(err => console.log(err))
  }, [navigate])

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageToDelete, setImageToDelete] = useState (null);

  const handleDeleteClick = (id) => {
    setImageToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (imageToDelete) {
      deleteImage(imageToDelete).then(res => {
        toast({
          status: "success",
          description: "Image deleted successfully",
        });
        getGallery().then(gal => {
          console.log(gal)
          setGallery(gal?.data);
        }).catch(err => {
          console.log(err)
          toast({
            status: "error",
            description: "Failed to delete image",
          });
        })
      })
    }
    setIsModalOpen(false);
    setImageToDelete(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setImageToDelete(null);
  };

  return (
    <>
      <BannerSectionStyle2
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Gallery"
        subTitle="Gallery Upload Page"
      />
      <Section
        topMd={170}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
        className='flex justify-center items-center w-full'
      >
        <div className="mt-[5%] p-4">
          <h1 className="text-center text-xl font-semibold">Upload Image to Gallery</h1>
          <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg p-6 flex flex-col gap-4 my-[5%]">
            {/* File Input */}
            <label className="cursor-pointer flex flex-col items-center gap-2 border-2 border-dashed border-[#981D0E] rounded-lg p-4 text-gray-600 hover:bg-blue-50">
              <span className="text-lg font-medium">Click to Upload</span>
              <input type="file" multiple onChange={handleFileChange} className="hidden" />
            </label>
            {/* Image Previews */}
            {imagePreviews.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {imagePreviews.map((src, index) => (
                  <img key={index} src={src} alt={`Preview ${index}`} className="w-24 h-24 object-cover rounded-lg border border-gray-200 shadow" />
                ))}
              </div>
            )}
            {/* Upload Button */}
            <button
              onClick={handleUpload}
              disabled={uploading}
              className="w-full px-4 py-2 text-white bg-[#981D0E] rounded-lg hover:bg-[#F5ABAB] transition disabled:opacity-50"
            >
              {uploading ? "Uploading..." : "Upload Image"}
            </button>
            {/* Uploaded Images */}
            {uploadedImages.length > 0 && (
              <div className="mt-4">
                <p className="text-gray-700 font-semibold">Uploaded Images:</p>
                <div className="flex flex-wrap gap-2 mt-2">
                  {uploadedImages.map((url, index) => (
                    <img key={index} src={url} alt={`Uploaded ${index}`} className="w-24 h-24 object-cover rounded-lg border border-gray-300 shadow-md" />
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="mt-[5%]">
            <h1 className="text-center text-xl font-semibold">Gallery</h1>
            <div className="px-4 lg:px-[10%] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {gallery.length > 0 ? (
                gallery.map((image) => (
                  <div
                    onClick={() => handleDeleteClick(image._id)}

                    key={image.id}
                    className="relative group overflow-hidden rounded-lg shadow-lg"
                  >
                    {/* Image */}
                    <img
                      src={image.url}
                      alt={image.alt || 'Gallery image'}
                      className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    {/* Delete Button */}
                    <button
                      className="absolute top-2 right-2 bg-[#981D0E] text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-[#F5ABAB]"
                      title="Delete image"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                ))
              ) : (
                <p className="col-span-full text-center text-gray-500">
                  No images in the gallery
                </p>
              )}
            </div>

            {/* Confirmation Modal */}
            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
                  <h3 className="text-lg font-semibold mb-4">
                    Confirm Deletion
                  </h3>
                  <p className="mb-6">
                    Are you sure you want to delete this image? This action cannot be undone.
                  </p>
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={closeModal}
                      className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={confirmDelete}
                      className="px-4 py-2 bg-[#981D0E] text-white rounded hover:bg-[#F5ABAB] transition-colors"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Section>
    </>
  );
}
